/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/Tabs/theme';

export const TabsTheme = theme;
